import axios from "axios";
import {
  popularGamesURL,
  upcomingGamesURL,
  newGamesURL,
  searchedURL,
} from "../api";

// ? Load games
export const loadGames = (length) => async (dispatch) => {
  try {
    // ? Fetch
    const popularGames = await axios.get(popularGamesURL(length));
    const upcomingGames = await axios.get(upcomingGamesURL());
    const newGames = await axios.get(newGamesURL());

    dispatch({
      type: "FETCH_GAMES",
      payload: {
        popular: popularGames.data.results,
        upcoming: upcomingGames.data.results,
        new: newGames.data.results,
      },
    });
  } catch (error) {
    console.log(error);
  }
};

export const loading = () => (dispatch) => {
  dispatch({
    type: "LOADING_GAMES",
  });
};

export const searchedGame = (gameName) => async (dispatch) => {
  try {
    dispatch({
      type: "CLEAR_SEARCH",
    });
    // ? Fetch
    const searched = await axios.get(searchedURL(gameName));

    dispatch({
      type: "FETCH_SEARCHED",
      payload: { searched: searched.data.results },
    });
  } catch (error) {
    console.log(error);
  }
};
